import React, { Component, Fragment } from 'react'

import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AdminApp from './AdminApp'
import { Redirect, Route } from 'react-router-dom'

import * as authSelectors from '../selectors/auth'

const propTypes = {
  allowedRoles: PropTypes.array.isRequired,
  rest: PropTypes.object,
  user: PropTypes.object,
  renderAdminApp: PropTypes.boolean
}

class PrivateRoute extends Component {
  render() {
    const { component: Component, allowedRoles, user, ...rest } = this.props
    const allowed = _.some(user.roles, role => _.includes(allowedRoles, role))
    const Parent = this.props.renderAdminApp ? AdminApp : Fragment

    return (
      <Parent>
        <Route
          {...rest}
          render={props =>
            user !== null && allowed === true ? <Component {...props} /> : <Redirect to="/login" />
          }
        />
      </Parent>
    )
  }
}

const mapStateToProps = (state, props) => ({
  user: authSelectors.getUser(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({})

PrivateRoute.propTypes = propTypes
PrivateRoute.defaultProps = {
  renderAdminApp: true
}
export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js